import { render } from "./SaleHours.vue?vue&type=template&id=e29eb996&scoped=true&ts=true"
import script from "./SaleHours.vue?vue&type=script&lang=ts"
export * from "./SaleHours.vue?vue&type=script&lang=ts"

import "./SaleHours.vue?vue&type=style&index=0&id=e29eb996&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29eb996"]])

export default __exports__